import { Link } from "react-router-dom";
import { ArrowRight, Star } from "lucide-react";
import { PACK_IMG, shippingLabel } from "@/data/content";
import { bagsOf, isBuilder, money, perBagMoney, useShop } from "@/lib/shop";
import { Reveal, Eyebrow } from "./Reveal";

export const MostPopular = () => {
  const { products } = useShop();
  const box = products.find((p) => isBuilder(p) && bagsOf(p.title) === 12);
  return (
    <section data-testid="home-most-popular" className="py-20 lg:py-28">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
        <Reveal className="grid lg:grid-cols-12 gap-8 items-center rounded-[36px] bg-white border border-[#1B1530]/10 p-4 sm:p-6 lg:p-8">
          <Link to="/build?size=12" className="lg:col-span-7 relative block rounded-[28px] overflow-hidden aspect-[16/10] group">
            <img src={PACK_IMG["build-your-own-box-12-pack"]} alt="Build your own 12-bag box" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
            <span className="absolute top-4 left-4 rounded-full bg-[#FFB21A] text-[#1B1530] text-xs font-bold uppercase px-3 py-1.5 inline-flex items-center gap-1"><Star className="h-3.5 w-3.5 fill-current" /> Most popular</span>
          </Link>
          <div className="lg:col-span-5 lg:pr-6">
            <Eyebrow className="text-[#FF5A5F] mb-4">Build your own box</Eyebrow>
            <h2 className="font-display text-4xl sm:text-6xl leading-[0.95]">The 12-pack, your way.</h2>
            <p className="mt-5 text-base sm:text-lg text-[#4A4560] leading-relaxed">Pick any mix of our 5 flavours. 12 bags, 264g of protein, and just 150 calories a bag.</p>
            <div className="mt-6 flex flex-wrap items-end gap-x-4 gap-y-1">
              <span data-testid="home-most-popular-price" className="font-display text-5xl leading-none">{box ? money(box.price) : "$71.99"}</span>
              {box && <span className="text-sm font-semibold text-[#4A4560] pb-1">{perBagMoney(box.price / 12)}/bag{shippingLabel(box.price) ? ` · ${shippingLabel(box.price)}` : ""}</span>}
            </div>
            <Link to="/build?size=12" data-testid="home-most-popular-cta"
              className="mt-8 inline-flex items-center gap-3 h-14 pl-7 pr-2 rounded-full bg-[#FF5A5F] text-white font-bold hover:bg-[#1B1530] transition-colors">
              Build my 12-pack <span className="h-10 w-10 rounded-full bg-white text-[#1B1530] grid place-items-center"><ArrowRight className="h-4 w-4" /></span>
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
